import React, { useEffect, useState } from 'react';
import { Card, Spinner } from "react-bootstrap";
import { useLocation } from "react-router-dom";

export default function LoadingLoginScreen() {
    const [locState, setLocState] = React.useState("")

    let location = useLocation();


    React.useState(() => {
        if (location.pathname === "/lead") {
            setLocState("lead")
        } else {
            setLocState("Verifierar...")
        }
    }, [])

    return (
        <Card style={{
            height: 170,
            width: 170,
            backgroundColor: "#5291CA",
            position: "absolute",
            zIndex: 5,
            justifySelf: "center",
            justifyContent: "center",

        }}>
            <span style={{ alignSelf: "center", color: "white", paddingBottom: 20 }}>
                {locState}
            </span>
            <Spinner color="white" animation="border" style={{ alignSelf: "center", color: "white" }} />
        </Card>
    )
}

